'use strict';
var Division, FIVE_MINUTES_IN_MS, cllCookie, decodeAddress, filterLocationData, geoStorageKey, getFullAddressFromSearchLocCookie, getGeolocationData, getInitialGeolocationAddress, getInitialLocation, getInitialLocationData, getLatLngPayload, getLatLngSearchLoc, getSearchLocCookie, getTranslations, getUserSearchLocData, isEmpty, pick, presentAddress, ref, removeGeolocationData, setELLCookie, setELLFromSearchLoc, setGeolocationData, setSearchLocCookie, uniq, userFriendlyLocation,
  slice = [].slice;

FIVE_MINUTES_IN_MS = 1000 * 60 * 5;

geoStorageKey = 'LS_geolocation';

getTranslations = require('./m_typeahead_helper').getTranslations;

ref = require('../../general/m_underscore_replacements'), pick = ref.pick, uniq = ref.uniq, isEmpty = ref.isEmpty;

Division = (function(currentDivision) {
  return {
    get: function() {
      return currentDivision;
    },
    set: function(division) {
      return currentDivision = division;
    }
  };
})(null);


/**
 * Get decoded address
 *
 * @param   {String} [address] - Encoded address string
 * @returns {String}           - Key value or empty object
 */

decodeAddress = function(address) {
  if (address == null) {
    address = '';
  }
  return decodeURIComponent(address).replace(/\+/g, ' ');
};


/**
 * Retrieve geolocation data from localStorage
 *
 * @param   {String}        [key] - Key name (optional)
 * @returns {String|Object} data  - Geodata object or specific data
 */

getGeolocationData = function(key) {
  var data, ref1;
  try {
    if ((data = (ref1 = window.localStorage) != null ? ref1.getItem(geoStorageKey) : void 0) != null) {
      data = JSON.parse(data);
      if (typeof key === 'string') {
        data = data[key];
      }
    }
  } catch (error) {}
  return data || {};
};


/**
 * Retrieve location name from various sources
 *
 * @returns {String} location - Location name or empty string
 */

getInitialLocation = function() {
  var division, divisionData, location;
  divisionData = Division != null ? Division.get() : void 0;
  division = divisionData != null ? divisionData.id : void 0;
  location = '';
  if ((location = getInitialGeolocationAddress(division))) {
    return location;
  }
  if ((location = getFullAddressFromSearchLocCookie())) {
    return location;
  }
  if ((location = userFriendlyLocation(divisionData))) {
    return location;
  }
  return '';
};


/**
 * Get location data
 *
 * @returns {Object} latLong - Location object
 */

getInitialLocationData = function() {
  var geoData, grab, latLong, locationData, queryParams;
  grab = function() {
    var data, i, j, len, properties, source, sources;
    sources = 2 <= arguments.length ? slice.call(arguments, 0, i = arguments.length - 1) : (i = 0, []), properties = arguments[i++];
    for (j = 0, len = sources.length; j < len; j++) {
      source = sources[j];
      data = pick(source || {}, properties);
      if (!isEmpty(data)) {
        break;
      }
    }
    return data;
  };
  queryParams = Groupon.Utils.unparam();
  locationData = getUserSearchLocData();
  latLong = grab(queryParams, locationData, Division.get(), ['lat', 'lng']);
  geoData = grab(queryParams, locationData, ['administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
  return latLong = Object.assign(latLong, geoData);
};


/**
 * Get "search_loc" cookie data
 *
 * @returns {Object} - search_loc - Search_loc data
 */

getSearchLocCookie = function() {
  var payload, search_loc;
  search_loc = {};
  if ((payload = Cookie.get('search_loc')) != null) {
    try {
      search_loc = JSON.parse(decodeURIComponent(payload));
    } catch (error) {
      try {
        search_loc = decodeURIComponent(JSON.parse(payload));
      } catch (error) {}
    }
  }
  return search_loc;
};


/**
 * Retrieve address from "search_loc" cookie
 *
 * @returns {String} - Address or empty string
 */

getFullAddressFromSearchLocCookie = function() {
  var friendlyName, fullAddress, ref1;
  ref1 = getSearchLocCookie(), fullAddress = ref1.fullAddress, friendlyName = ref1.friendlyName;
  return decodeAddress(fullAddress) || decodeAddress(friendlyName);
};


/**
 * Retrieve data from "search_loc" cookie
 *
 * @returns {Object} - Relevant location data
 */

getUserSearchLocData = function() {
  var search_loc;
  search_loc = getSearchLocCookie();
  return pick(search_loc, ['lat', 'lng', 'administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
};


/**
 * Returns current location label if division match current location division
 *
 * @param   {String} division - Division from itier division data
 * @returns {String} label    - Current location label or undefined
 */

getInitialGeolocationAddress = function(division) {
  var label, ref1;
  label = '';
  if (division && division === getGeolocationData('current_location')['closestDivision']) {
    label = (ref1 = getTranslations('search')) != null ? ref1.nearme : void 0;
  }
  return label;
};


/**
 * Changes address to remove duplicate address sections and country "USA"
 *
 * @param   {String} address - Address returned by Google Maps
 * @returns {String}         - Formatted address
 */

presentAddress = function(address) {
  var splitAddress;
  address = address.replace(/(\s\d{5})?,\sUSA$/, '');
  splitAddress = address.split(', ');
  return uniq(splitAddress).join(', ');
};


/**
 * Removes geolocation key from localStorage / cookie
 *
 * @param {String} key - LocalStorage key name
 */

removeGeolocationData = function(key) {
  var data, ref1;
  if (key != null) {
    data = getGeolocationData();
    delete data[key];
    data = JSON.stringify(data);
    try {
      if ((ref1 = window.localStorage) != null) {
        ref1.setItem(geoStorageKey, data);
      }
    } catch (error) {
      Cookie.set(geoStorageKey, encodeURIComponent(data));
    }
  }
};


/**
 * LS-2274 Set new location cookie "ell"
 *
 * @param {String} data - String contain <lat>,<lng>
 */

setELLCookie = function(data) {
  Cookie.set('ell', data);
};

setELLFromSearchLoc = function() {
  var data;
  if (!Cookie.get('ell')) {
    data = getLatLngSearchLoc();
    if (data) {
      Cookie.set('ell', data);
    }
  }
};


/*
 * LS-2273 current location cookie "cll"
 */

cllCookie = {

  /**
   * LS-2273 Set new current location cookie "cll"
   *
   * @param {Object} location - Object containing coordinates
   */
  set: function(location) {
    var TTL, lat, lng, ref1;
    if (!(location != null ? location.coords : void 0)) {
      return;
    }
    ref1 = location.coords, lat = ref1.latitude, lng = ref1.longitude;
    Cookie.set('cll', lat + ',' + lng);
    TTL = Date.now() + FIVE_MINUTES_IN_MS;
    try {
      if (typeof localStorage !== "undefined" && localStorage !== null) {
        localStorage.setItem('cll_TTL', TTL);
      }
    } catch (error) {
      setSiteCookies({
        cll_TTL: TTL
      }, FIVE_MINUTES_IN_MS);
    }
  },

  /*
   * LS-2273 remove current location cookie "cll"
   */
  remove: function() {
    return Cookie.unset('cll');
  }
};

getLatLngPayload = function() {
  var division;
  if (division = Division.get()) {
    return division.lat + ',' + division.lng;
  } else {
    return '';
  }
};

getLatLngSearchLoc = function() {
  var lat, lng, ref1;
  ref1 = getSearchLocCookie(), lat = ref1.lat, lng = ref1.lng;
  if (lat && lng) {
    return lat + ',' + lng;
  } else {
    return '';
  }
};


/**
 * Sets geolocation key/value pair to localStorage / cookie
 *
 * @param {String} key   - LocalStorage key name
 * @param {String} value - Value to be set
 */

setGeolocationData = function(key, value) {
  var data, ref1;
  if ((key != null) && (value != null)) {
    data = getGeolocationData();
    data[key] = value;
    try {
      if ((ref1 = window.localStorage) != null) {
        ref1.setItem(geoStorageKey, JSON.stringify(data));
      }
    } catch (error) {}
  }
};

filterLocationData = function(data) {
  return pick(data, ['lat', 'lng', 'closestDivision', 'friendlyName', 'fullAddress', 'administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
};


/**
 * Sets "search_loc" cookie storing various data gathered from Gmaps and API responses
 *
 * @param {Object} data - Location data object
 */

setSearchLocCookie = function(data) {
  data = filterLocationData(data);
  Cookie.set('search_loc', encodeURIComponent(JSON.stringify(data)));
};


/**
 * Returns Division Name
 *
 * @param   {Object} division - Division from itier division data
 * @returns {String} name     - Division name
 */

userFriendlyLocation = function(division) {
  var abbreviation, name, state;
  if (!(division != null ? division.name : void 0)) {
    return '';
  }
  name = division.name, state = division.state;
  if (abbreviation = state != null ? state.abbreviation : void 0) {
    name = name + ", " + abbreviation;
  }
  return name;
};

module.exports = {
  cllCookie: cllCookie,
  decodeAddress: decodeAddress,
  filterLocationData: filterLocationData,
  getDivision: Division.get,
  getGeolocationData: getGeolocationData,
  getFullAddressFromSearchLocCookie: getFullAddressFromSearchLocCookie,
  getInitialGeolocationAddress: getInitialGeolocationAddress,
  getInitialLocation: getInitialLocation,
  getInitialLocationData: getInitialLocationData,
  getLatLngPayload: getLatLngPayload,
  getLatLngSearchLoc: getLatLngSearchLoc,
  getSearchLocCookie: getSearchLocCookie,
  getUserSearchLocData: getUserSearchLocData,
  presentAddress: presentAddress,
  removeGeolocationData: removeGeolocationData,
  setDivision: Division.set,
  setELLCookie: setELLCookie,
  setELLFromSearchLoc: setELLFromSearchLoc,
  setGeolocationData: setGeolocationData,
  setSearchLocCookie: setSearchLocCookie,
  userFriendlyLocation: userFriendlyLocation
};

